import * as I from 'immutable';
import { createSelectorCreator, defaultMemoize, Selector } from 'reselect';

// Extending the Reselect Selector type to include our custom methods
export interface ExtendedSelector<S, T> extends Selector<S, T> {
  then<U>(this: ExtendedSelector<S, T>, s: (subState: T) => Selector<S, U>): ExtendedSelector<S, U>;
  map<U>(this: ExtendedSelector<S, T>, f: (val: T) => U): ExtendedSelector<S, U>;
}

export const peek =
  (...path: Array<string | number>) =>
  (obj: any) =>
    I.Iterable.isIterable(obj) ? obj.getIn(path) : undefined;

function sThen<S, T, U>(this: ExtendedSelector<S, T>, s: (subState: T) => Selector<S, U>) {
  return selector((state: S) => s(this(state))(state));
}

const CustomSelectorCreator = createSelectorCreator(defaultMemoize, I.is);

export function selector<S, T>(...args: any[]): ExtendedSelector<S, T> {
  function sMap<U>(this: ExtendedSelector<S, T>, f: (val: T) => U) {
    return selector(this, f);
  }

  const res = CustomSelectorCreator(...(args as [any])) as ExtendedSelector<S, T>;
  res.then = sThen;
  res.map = sMap;
  return res;
}

export const select = <S, T>(f: (state: S) => T) => selector((x: S) => x, f);
